<footer class="bg-[#000A73]">
  <div class="mx-auto max-w-[90rem] px-5 py-10 text-white lg2:px-8">
    <div
      class="flex flex-col flex-wrap gap-x-7 gap-y-5 border-b-[1px] border-b-[#CCCCCC] pb-16 text-sm lg2:flex-row lg2:items-center lg2:gap-y-0 lg2:border-b-white lg2:pb-5"
      role="navigation"
      aria-label="Footer links"
    >
      <a
        href="https://www.xfinity.com/privacy/policy"
        class="comcast-white-link !no-underline"
        target="_blank"
        rel="noopener noreferrer"
        >Privacy Policy</a
      >
      <a
        href="https://www.xfinity.com/privacy/your-privacy-choices"
        class="comcast-white-link !no-underline"
        target="_blank"
        rel="noopener noreferrer"
        >Your Privacy Choices</a
      >
      <a
        href="https://www.xfinity.com/privacy/policy/staterights#california"
        class="comcast-white-link !no-underline"
        target="_blank"
        rel="noopener noreferrer"
        >Notice at Collection</a
      >
      <a
        href="https://www.xfinity.com/corporate/legal/visitoragreement"
        class="comcast-white-link !no-underline"
        target="_blank"
        rel="noopener noreferrer"
        >Visitor Agreement</a
      >
      <a
        href="https://business.comcast.com/enterprise/terms-conditions/nitel"
        class="comcast-white-link !no-underline"
        target="_blank"
        rel="noopener noreferrer"
        >Terms &amp; Conditions</a
      >
      @if (!isPublic) {
        <a routerLink="/noc-policy" class="comcast-white-link !no-underline">
          NOC Policy
        </a>
      }
    </div>

    <div class="mt-5 text-[11px] text-[#CCCCCC] lg2:mt-10 lg2:text-[#EFEFEF]">
      ©{{ currYear }} Comcast Corporation. All Rights Reserved
    </div>
  </div>
</footer>
